import { apiHelper } from "../utils/apiHelper";

const API_URL = `${process.env.REACT_APP_API_URL}/api/org/theme-colors`;
const API_URL_PUBLIC = `${process.env.REACT_APP_API_URL}/api/org/theme-colors-bulk`;

export const fetchColors = async ({
  organization_id,
  page = 1,
  search = "",
  limit = 100,
}) => {
  const query = new URLSearchParams({
    organization_id,
    page,
    search,
    limit,
  }).toString();
  const url = `${API_URL}?${query}`;

  const response = await apiHelper(url, "GET");
  return {
    data: response.data?.data || [],
    total_records: response.data?.total_records || 0,
    success: response.data?.success || false,
    message: response.data?.message || "",
  };
};

export const createColor = (payload) => {
  return apiHelper(API_URL_PUBLIC, "POST", payload);
};
